// Feature flags for the main portal.
//
// FIELD_ASSIST_ENABLED gates the Field Assist feature (subcontractor voice-first appliance chat + admin review),
// which is PORTED into this branch but NOT yet deployable — its backend (`fi-field-assist` edge function + the
// `field_intel` migrations) can only go live after the production migration squash lands. Default OFF so the code
// can ship dark. Turn it on locally with `VITE_FIELD_ASSIST_ENABLED=true` in .env.local to see/use the feature.
export const FIELD_ASSIST_ENABLED =
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_FIELD_ASSIST_ENABLED === 'true') || false;

// UNIFORM_ORDERING_LIVE gates the crew-facing side of uniform ordering. The
// admin desk (catalogue + requests) is always on. Shipped dark 20 Sep 2026;
// owner opened it to crews 21 Sep 2026. Set false (or
// VITE_UNIFORM_ORDERING_LIVE=false has no effect — edit here) to go dark again.
export const UNIFORM_ORDERING_LIVE = true;
